import { QueuePage } from "./components/QueuePage";
import { ModuleErrorBoundary } from "@hub/ui/components/ErrorBoundary";

export function QueueRoutes() {
  return (
    <ModuleErrorBoundary moduleName="Queue">
      <QueuePage />
    </ModuleErrorBoundary>
  );
}
